import { render, staticRenderFns } from "./CollaboratorCount.vue?vue&type=template&id=299c1876&scoped=true&"
import script from "./CollaboratorCount.vue?vue&type=script&lang=js&"
export * from "./CollaboratorCount.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorCount.vue?vue&type=style&index=0&id=299c1876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299c1876",
  null
  
)

export default component.exports